module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onClickedOutside),
      expression: "onClickedOutside"
    }]
  }, [_c('span', {
    ref: "trigger",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "popover",
    staticClass: "vux-popover",
    style: (_vm.popoverStyle)
  }, [_c('div', {
    class: _vm.arrowClass
  }), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.$emit('on-click-content')
      }
    }
  }, [_vm._t("content", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2048bcb5"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/popover/index.vue
// module id = 478
// module chunks = 4